import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"
import { get } from "@rails/request.js"

/**
 * SelectableController - Maneja selects mejorados con SlimSelect
 * Conecta a data-controller="selectable"
 */
export default class extends Controller {
  static values = {
    allowDeselect: Boolean,
    closeOnSelect: Boolean,
    disabled: Boolean,
    hideSelected: Boolean,
    placeholder: String,
    searchable: Boolean,
    url: String,
  }

  #select = null

  connect() {
    this.#initializeSlimSelect()
    
    if (this.searchableValue) {
      this.#setupSearchFunctionality()
    }
  }

  disconnect() {
    this.#select?.destroy()
  }

  allowDeselection(event) {
    event.stopImmediatePropagation()
    this.#select.settings.allowDeselect = !!event.target.value
  }

  #initializeSlimSelect() {
    // Convierte la opción vacía nativa (p. ej. `include_blank` de Rails) en el
    // placeholder de SlimSelect: debe llevar data-placeholder="true" para tratarse
    // como valor vacío por defecto en lugar de una fila más. Su texto pasa a ser
    // el texto del placeholder.
    const blank = this.element.querySelector('option[value=""]')
    let placeholderText = this.placeholderValue

    if (blank) {
      blank.dataset.placeholder = "true"
      placeholderText = placeholderText || blank.textContent.trim()
      blank.textContent = ""
    }

    this.#select = new SlimSelect({
      select: this.element,
      settings: {
        closeOnSelect: this.closeOnSelectValue ?? true,
        searchText: 'Lo sentimos, no hay nada que ver aquí.',
        placeholderText: placeholderText || 'Selecciona valor',
        hideSelected: this.hideSelectedValue ?? true,
        allowDeselect: this.allowDeselectValue ?? false,
        disabled: this.disabledValue ?? false,
      }
    })
  }

  #setupSearchFunctionality() {
    const form = this.element.closest('form')
    const formData = new FormData(form)
    const entries = Object.fromEntries(formData.entries())
    const params = new URLSearchParams(
      Object.entries(entries).filter(([_, value]) => Boolean(value))
    )

    this.#select.events.search = async (search, currentData) => {
      if (search) {
        params.set('q[name_cont]', search)
      }
      
      try {
        const response = await get(`${this.urlValue}?${params}`, { 
          responseKind: 'json' 
        })
        
        if (response.ok) {
          const { data } = await response.json
          return data.map(item => ({ 
            text: item.name, 
            value: item.id 
          }))
        }
        
        throw new Error('Request failed')
      } catch (error) {
        console.error('Search error:', error)
        return [{ text: 'Lo sentimos, ocurrió un error.' }]
      }
    }
  }
}
